<div class="top">
  @if (data.text) {
    <p>
      {{ data.text }}
    </p>
  }
  @if (data.preformattedText) {
    <pre>
      {{ data.preformattedText }}
      </pre
      >
    }
    @if (data.imgSrc) {
      <img [src]="data.imgSrc" />
    }
  </div>
